module.exports = __webpack_public_path__ + "img/speed-left.4c4c0f43.png";